export default "__VITE_ASSET__CWN$VMGB__"